import { getToken, refreshToken } from './keycloak';

export default function initFetchInterceptor() {
    const originalFetch = window.fetch;
    const apiBaseUrl = import.meta.env.VITE_REACT_APP_API_BASE_URL;

    // Create a fetch interceptor
    window.fetch = async function (resource, options = {}) {
        try {
            let url;
            let requestOptions = options;
            
            // Handle both string URLs and Request objects
            if (resource instanceof Request) {
                url = resource.url;
                // Create new options merging the Request and provided options
                requestOptions = {
                    ...options,
                    method: resource.method,
                    headers: {
                        ...Object.fromEntries(resource.headers.entries()),
                        ...options.headers
                    },
                    // Other Request properties as needed
                    credentials: resource.credentials,
                    mode: resource.mode,
                    cache: resource.cache,
                };
            } else {
                url = resource;
            }
            
            // Check if this is an internal API call to Henddus' backend
            const isInternalApi = typeof url === 'string' && url.includes(apiBaseUrl);
            
            // Only process authentication for internal APIs
            if (isInternalApi) {
                // Try to refresh the token before making request to internal API
                await refreshToken();
                
                // Get the current token
                const token = getToken();
                
                // Prepare headers with authentication
                const headers = requestOptions.headers || {};
                if (token) {
                    headers.Authorization = `Bearer ${token}`;
                }
                
                // Merge with original options for internal APIs
                const updatedOptions = {
                    ...requestOptions,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        ...headers
                    }
                };
                
                // Make the request with the intercepted fetch for internal APIs
                return originalFetch(url, updatedOptions);
            } else {
                // For external APIs or non-string resources, use original fetch
                return originalFetch(resource, options);
            }
        } catch (error) {
            console.error('Fetch interceptor error:', error);
            return Promise.reject(error);
        }
    };
}